export default __webpack_public_path__ + "static/media/icon-star.6ffadf5d.svg";